import React from "react";
import "./Footer.scss";

const Footer = () => {
  return (
    <footer className="Footer">
      <div className="Footer-container" >
        <div className="Footer-container_redes">
          <div className="Footer-container_redes--instagram">
            <a href="https://www.instagram.com/importacionfya/" target="_blank">
              <img
                className="Footer-container_redes--instagram__img"
                src="footer/instagram.png"
              ></img>
            </a>
          </div>
          <div className="Footer-container_redes--whatsapp">
            <a href="https://wa.me/5491159048769" target="_blank">
              <img
                className="Footer-container_redes--whatsapp__img"
                src="footer/whatsapp.png"
              ></img>
            </a>
          </div>
          <div className="Footer-container_redes--whatsapp">
            <a
              href="https://www.tiktok.com/@importacionfya?_t=8Zt6WYyNAXN&_r=1"
              target="_blank"
            >
              <img
                className="Footer-container_redes--tiktok__img"
                src="footer/tiktok.png"
              ></img>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
